<ion-content class="ion-padding">
  <div class="edit-option-modal">
    <h1>{{ 'posManager.editOption' | transloco }}</h1>
    <div class="modifier-type-info">
      <ion-chip color="danger">
        <ion-label>{{modifierTypeName}}</ion-label>
      </ion-chip>
    </div>
    <ng-container [formGroup]="form">
      <div class="edit-option-modal__form">
        <div>
          <ion-label><strong>{{ 'common.name' | transloco }}</strong><span *ngIf="!isReadonlyType"> ({{ 'common.required' | transloco }})</span></ion-label>
          <ion-input
                     formControlName="name"
                     maxlength="50"
                     [disabled]="isReadonlyType">
          </ion-input>
        </div>

        <div *ngIf="!isReadonlyType">
          <ion-label><strong>{{ 'posManager.price' | transloco }}</strong></ion-label>
          <ion-input type="number" formControlName="price"></ion-input>
        </div>
        <div>
          <ion-label><strong>{{ 'posManager.color' | transloco }}</strong></ion-label>
          <div class="color-options">
            <div *ngFor="let colorOption of colors"
                 class="color-option-wrapper"
                 [class.selected]="form.get('modifier_color')?.value === colorOption.value"
                 (click)="selectColor(colorOption.value)">
              <pos-modifier-color-tag
                                      [value]="colorOption.value"
                                      [editMode]="true"
                                      [showCheckmark]="form.get('modifier_color')?.value === colorOption.value">
              </pos-modifier-color-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-option-modal__actions">
        <ion-button color="clear" (click)="cancel()">{{ 'common.cancel' | transloco }}</ion-button>
        <ion-button [disabled]="!form.valid || !form.dirty" color="dark" (click)="submit()">{{ 'posManager.editOption' |
          transloco }}</ion-button>
      </div>
    </ng-container>
  </div>
</ion-content>